import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { api, endpoint } from "@/api";
import AlarmForm from "./AlarmForm";

const EditAlarm = () => {
  const Params = useParams();
  const alarmId = Params.alarmId;
  const [state, setState] = useState();

  const getAlarm = async () => {
    const data = await api.get(`${endpoint.notification}/${alarmId}`);
    if (data) {
      setState({
        ...data,
        site: data?.site?.map((item) => item?._id),
        device: data?.device?.map((item) => item?._id),
        parameter: data?.parameter?.map((item) => item?._id),
      });
    }
  };

  useEffect(() => {
    getAlarm();
  }, []);

  return <> {state && <AlarmForm mode="edit" alarmData={state} />} </>;
};

export default EditAlarm;
